module.exports = __webpack_public_path__ + "assets/media/lunch.c12797fb.mp3";